<script>
  import {getNotificationsContext} from "svelte-notifications"
  import DialogContent from "../../dialog/DialogContent.svelte";
  import Stack from "../../layout/Stack.svelte";
  import ContainerStyledRadioGroup from "../../input/ContainerStyledRadioGroup.svelte";
  import DialogBottomControls from "../../dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../dialog/DialogBottomControlButton.svelte";
  import {translate} from "../../../i18n/i18next.js";

  export let projectId
  export let moveNext
  export let closeDialog

  let selected = "existingUser"

  const {addNotification} = getNotificationsContext()

  async function onClickNext(selected) {
    const response = await fetch(`/api/projects/${projectId}/data/DispatchingView/resources`)
    if (!response.ok) {
      addNotification({
        text: translate("frontend:components.restrictedUserInvitationDialog.messages.dispatchingViewDataNeeded"),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      })
      return
    }
    moveNext(selected)
  }
</script>

<DialogContent>
  <span>
    {translate("frontend:components.restrictedUserInvitationDialog.steps.initial.caption")}
  </span>
  <ContainerStyledRadioGroup
    bind:value={selected}
    options={[{value: "existingUser"}, {value: "newUser"}]}
    let:option
  >
    {#if option.value === "existingUser"}
      <Stack direction="vertical" gap=".3rem">
        <span>{translate("frontend:components.restrictedUserInvitationDialog.steps.initial.select.existingUser.title")}</span>
        <span>{translate("frontend:components.restrictedUserInvitationDialog.steps.initial.select.existingUser.caption")}</span>
      </Stack>
    {:else if option.value === "newUser"}
      <Stack direction="vertical" gap=".3rem">
        <span>{translate("frontend:components.restrictedUserInvitationDialog.steps.initial.select.newUser.title")}</span>
        <span>{translate("frontend:components.restrictedUserInvitationDialog.steps.initial.select.newUser.caption")}</span>
      </Stack>
    {/if}
  </ContainerStyledRadioGroup>
</DialogContent>
<DialogBottomControls>
  <DialogBottomControlButton type="primary" onClick={() => onClickNext(selected)}>
    {translate("generic.next")}
  </DialogBottomControlButton>
  <DialogBottomControlButton type="secondary" onClick={() => closeDialog()}>
    {translate("generic.cancel")}
  </DialogBottomControlButton>
</DialogBottomControls>
